import gql from 'graphql-tag';

export const deactivateUzivatel = gql`
    mutation deactivateUzivatel($input: Int!){
      response: deactivateUzivatel(uzivatelId: $input)
    }
`;
